/* deep link: shop-all.html#Exotics etc. pre-selects a filter chip */
(function hashFilter(){
  var h=decodeURIComponent((location.hash||'').slice(1)); if(!h) return;
  var b=[].filter.call(document.querySelectorAll('.fchip'),function(c){
    return (c.dataset.f||'').toLowerCase()===h.toLowerCase(); })[0];
  if(b) b.click();
})();
